// Author lidongxu
// Date 2024-02-22 10:47:49

class SithMesStoolPrApplicationShippingDetail {
constructor({
        id = null,
        applicationNo = '',
        projectNo = '',
        wbsNo = '',
        glAccountNo = '',
        materialNo = '',
        materialDesc = '',
        quantity = '',
        deliveryData = '',
        consigneeAddress = '',
        buyer = '',
        remark = ''}
= {}) {
    this.id = id;
    this.applicationNo = applicationNo;
    this.projectNo = projectNo;
    this.wbsNo = wbsNo;
    this.glAccountNo = glAccountNo;
    this.materialNo = materialNo;
    this.materialDesc = materialDesc;
    this.quantity = quantity;
    this.deliveryData = deliveryData;
    this.consigneeAddress = consigneeAddress;
    this.buyer = buyer;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolPrApplicationShippingDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicationNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.applicationNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.projectNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.wbsNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'glAccountNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.glAccountNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.materialNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDesc',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.materialDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deliveryData',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.deliveryData',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'consigneeAddress',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.consigneeAddress',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'buyer',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.buyer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    applicationNoFilter : '',
    projectNoFilter : '',
    wbsNoFilter : '',
    glAccountNoFilter : '',
    materialNoFilter : '',
    materialDescFilter : '',
    quantityFilter : '',
    deliveryDataFilter : '',
    consigneeAddressFilter : '',
    buyerFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'applicationNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.applicationNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.projectNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.wbsNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'glAccountNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.glAccountNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.materialNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.materialDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryDataFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.deliveryData',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'consigneeAddressFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.consigneeAddress',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyerFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.filter.buyer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'applicationNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.applicationNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.projectNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.wbsNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'glAccountNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.glAccountNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.materialNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDesc',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.materialDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryData',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.deliveryData',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'consigneeAddress',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.consigneeAddress',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'buyer',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.buyer',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationShippingDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesStoolPrApplicationShippingDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
